import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formaterNumber'
})
export class FormaterNumberPipe implements PipeTransform {

  transform(
    value: number | null | undefined,
    decimals = 2,
    thousandsSeparator = ',',
    decimalSeparator = '.'
  ): string {

    if(value === null || !value) return '';

    const parts = value.toFixed(decimals).split('.');

    parts[0] = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      thousandsSeparator
    );

    return decimals > 0
     ? parts.join(decimalSeparator)
     : parts[0];
  }

}
